<ng-container>
  <div class="container-fluid container-md mt-5">
    <div
      *ngIf="wholesaleRetailKit.description === 'Wholesale'"
      class="equal-height-col p-0 border-primary-light"
    >
      <div class="row bg-primary-light m-0 p-0">
        <div class="col p-3">
          <h4 i18n>Consultant with wholesale discount</h4>
        </div>
      </div>
      <div class="row m-0 p-0">
        <div class="col p-2">
          <ul class="py-3">
            <li class="pb-3" i18n
              >You receive a 25% wholesale discount (based on the VSG Profitable Sales price) on
              yourresale purchases.</li
            >
            <li i18n
              >You have the opportunity to qualify for recruiting incentives with product
              rewards.</li
            >
          </ul>
        </div>
      </div>
    </div>
    <div
      *ngIf="wholesaleRetailKit.description === 'Retail'"
      class="equal-height-col p-0 border-grey-light"
    >
      <div class="row bg-grey-light m-0 p-0">
        <div class="col p-3">
          <h4 i18n>Profitable Consultant</h4>
        </div>
      </div>
      <div class="row m-0 p-0">
        <div class="col p-2">
          <ol class="py-2">
            <li class="pb-3" i18n>You receive 25% profit on your Sales Subject to Profit (VSG)</li>
            <li class="recibes-ganancias-de" i18n>You have the opportunity to:</li>
            <ul>
              <li i18n
                >Earn an additional 5 or 10% profit each Period when your SGV per Period reaches
                $30,000 SGV or more</li
              >
              <li i18n>Qualify for sales and recruiting incentives with product or cash rewards</li>
              <li i18n
                >Form a group by promoting to Unit Organizer, our first level of leadership</li
              >
            </ul>
          </ol>
        </div>
      </div>
    </div>
  </div>
</ng-container>
